// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "wrapper-o04Ak";
var _4 = "root-2Zdf7";
var _5 = "aside-3T5al";
var _6 = "map-2IMOM";
var _7 = "overlay--Vboa";
var _8 = "aside_left-3i6A0";
var _9 = "aside_right-1zh-m";
export { _1 as "__esModule", _2 as "tablet", _3 as "wrapper", _4 as "root", _5 as "aside", _6 as "map", _7 as "overlay", _8 as "aside_left", _9 as "aside_right" }
export default { "__esModule": _1, "tablet": _2, "wrapper": _3, "root": _4, "aside": _5, "map": _6, "overlay": _7, "aside_left": _8, "aside_right": _9 }
